angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/accounts', {
            templateUrl: 'accounts/accounts.html',
            controller: 'AccountsCtrl',
            role: 'ADMIN',
            title: 'Accounts'
        })

        .when('/account/:accountId', {
            templateUrl: 'account/account.html',
            controller: 'AccountCtrl',
            role: 'ADMIN',
            title: 'Advertisers'
        })
});
